import CommandesController from './commandes.controller';

export default {
    template: require('./commandes.tpl.html'),
    controller: CommandesController
};
